import React from 'react';
import './OverageBanner.css';

function formatDate(isoString) {
  if (!isoString) return '';
  const d = new Date(isoString);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export default function OverageBanner({ used, quota, overageCostCents, periodEnd, nextTier, onDismiss }) {
  if (!used || !quota || used < quota) return null;

  const periodEndDisplay = formatDate(periodEnd);

  return (
    <div className="overage-banner" role="alert">
      <div className="overage-banner__content">
        <div className="overage-banner__text">
          <p className="overage-banner__headline">
            You've used all <strong>{quota}</strong> prompts included in your plan for this month.
          </p>
          {periodEndDisplay && (
            <p className="overage-banner__detail">
              Messages until {periodEndDisplay} will be charged at <strong>$0.25</strong> each.
            </p>
          )}
          {nextTier && (
            <p className="overage-banner__upgrade-hint">
              Upgrade to <strong>{nextTier.name}</strong> for {nextTier.monthly_prompt_quota} prompts at ${(nextTier.price_cents / 100).toFixed(2)}/mo, starting next month.
            </p>
          )}
        </div>
        <div className="overage-banner__actions">
          {onDismiss && (
            <button className="overage-banner__dismiss" onClick={onDismiss} aria-label="Dismiss">
              &times;
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
